import React, { useCallback, useRef } from 'react'

// https://medium.com/swlh/using-a-debounced-callback-in-react-ade57d31ca6b
export default (func, wait) => {
  const timeout = useRef()

  return useCallback(
    (...args) => {
      const later = () => {
        clearTimeout(timeout.current)
        func(...args)
      }

      clearTimeout(timeout.current)
      timeout.current = setTimeout(later, wait)
    },
    [func, wait]
  )
}
